import { useEffect } from 'react';

// Redirects to Real Chemistry's Greenhouse job board
function JobCategoryRedirect() {
  useEffect(() => {
    window.location.replace('https://boards.greenhouse.io/realchemistry');
  }, []);

  return null;
}

export default JobCategoryRedirect;
